/** @deprecated */
export const enum SLAEventPhase {
    Start = 'start',
    End = 'end',
    Error = 'error',
}
